import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { StarIcon } from 'elc-icons';
import { starTheme, selectedStarTheme } from '../theme/default-theme';
import { ContentSpacing } from 'elc-base-theme';

export interface IStar {
    className?: string;
    index?: number;
    selected?: boolean;
    clickHandler?(index: number): void;
    isDisabled?: boolean;
}

export interface IStarStyle {
    isDisabled: boolean | undefined;
}

const StarWrapper = styled.span`
    display: inline-block;
    margin-right: ${ContentSpacing.space8};
    cursor: ${({ isDisabled }: IStarStyle) => (isDisabled ? 'default' : 'pointer')};
    [dir='rtl'] & {
        margin-right: 0;
        margin-left: ${ContentSpacing.space8};
    }
`;

const StarElement = styled(StarIcon)`
    ${starTheme};
    &.elc-star-selected {
        ${selectedStarTheme};
    }
    &:hover {
        stroke-width: ${({ isDisabled }: IStarStyle) => (isDisabled ? '1px' : '2px')};
    }
`;

export const Star = observer((props: IStar) => {
    const classNames = classnames('elc-star', 'js-star', props.className, {
        'elc-star-selected': props.selected
    });
    const starWrapperClassNames = classnames('elc-star-wrapper', 'js-star-wrapper');

    const onStarClick = () => {
        if (props.clickHandler && props.index) {
            props.clickHandler(props.index);
        }
    };

    return (
        <StarWrapper
            onClick={onStarClick}
            isDisabled={props.isDisabled}
            className={starWrapperClassNames}
        >
            <StarElement className={classNames} isDisabled={props.isDisabled} />
        </StarWrapper>
    );
});
